/* eslint-disable no-useless-catch */
import { apiPayments } from "@auteco/enviroment/apiPayments"
import { loaderService } from "./loaderService"

export const getPayments = async () => {
    loaderService.show()
    try {
        const response = await apiPayments.get('/facturas/consultar')
        if (response.status === 200) {
            return response.data
        }
    } catch (error) {
        throw error
    } finally {
        loaderService.hide()
    }
}

export const postPaymentStatus = async ({ params }) => {
    loaderService.show()
    try {
        const response = await apiPayments.post('/facturas/validar_manual', params)
        if (response.status === 200) {
            return response.data
        }
    } catch (error) {
        throw error
    } finally {
        loaderService.hide()
    }
}